import React from 'react';
import { palette } from '../../style-utils/theme';

interface DownArrowProps {
  stroke?: string;
}

/* DECORATION. This glyph always sits beside its own text label, so
   exposing it to the accessibility tree only adds a nameless graphic
   before every button that uses it. */
export const DownArrow: React.FC<DownArrowProps> = ({
  stroke = palette.slate,
}) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 9L12 15L6 9"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
